module.exports = __webpack_public_path__ + "img/back pocket height.c6f8ab4a.png";